





























































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'

export interface InputOfReserveContactSituationReserveInfoItem {
  contactMethod: SystemCode
  registrationBranchCode: SystemCode
  registrationTime: string
  reserveNoticeAllowed: boolean
  registrationPlaceCode: SystemCode
  preferredDate: string
  forwardingBranchCode: SystemCode
  forwardingPlaceCode: SystemCode
}

export const defaultInputOfReserveContactSituationReserveInfoItem = (): InputOfReserveContactSituationReserveInfoItem => ({
  contactMethod: defaultSystemCode(),
  registrationBranchCode: defaultSystemCode(),
  registrationTime: '',
  reserveNoticeAllowed: false,
  registrationPlaceCode: defaultSystemCode(),
  preferredDate: '',
  forwardingBranchCode: defaultSystemCode(),
  forwardingPlaceCode: defaultSystemCode()
})

@Component({
  components: {}
})
export default class InputOfReserveContactSituationReserveInfo extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: InputOfReserveContactSituationReserveInfoItem
}
